<template>
  <div></div>
</template>

<script>
export default {
  name: "a-rms-day-empty"
};
</script>
